import { styled } from "styled-components";

export const ErrorPanel = styled.div`
  margin-bottom: 1rem;
  background: #f7ebeb;
  border-radius: 6px;
  overflow: hidden;
  padding: 1rem;
`;

export const Error = styled.div`
  color: ${(props) => props.theme.colours.error};
`;
